import { jsx as _jsx } from "react/jsx-runtime";
import memoize from 'fast-memoize';
import startCase from 'lodash.startcase';
import { CollectionResourceRules } from './CollectionResourceRules';
import { CommunityResourceRules } from './CommunityResourceRules';
import { MemberResourceRules } from './MemberResourceRules';
import { SpaceResourceRules } from './SpaceResourceRules';
import { TagResourceRules } from './TagResourceRules';
export const ResourceAliases = memoize((intl) => {
    return {
        ...CommunityResourceRules(intl),
        ...CollectionResourceRules(intl),
        ...SpaceResourceRules(intl),
        ...MemberResourceRules(intl),
        ...TagResourceRules(intl),
        /**
         * @tag Re-branding
         */
        BRAND: 'Bettermode',
        DOMAIN: 'bettermode.io',
        // Default rich text elements doesn't support self-closing tags
        // See https://github.com/formatjs/formatjs/issues/1597
        br: _jsx("br", {}, void 0),
    };
});
export const DefaultElements = {
    small: chunks => _jsx("small", { children: chunks }, void 0),
    strong: chunks => _jsx("strong", { children: chunks }, void 0),
    p: chunks => _jsx("p", { children: chunks }, void 0),
    h1: chunks => _jsx("h1", { children: chunks }, void 0),
    h2: chunks => _jsx("h2", { children: chunks }, void 0),
    h3: chunks => _jsx("h3", { children: chunks }, void 0),
    h4: chunks => _jsx("h4", { children: chunks }, void 0),
    lower: chunks => chunks.map(chunk => {
        if (typeof chunk === 'string') {
            return chunk.toLowerCase();
        }
        return chunk;
    }),
    capital: chunks => chunks.map(chunk => {
        if (typeof chunk === 'string') {
            return startCase(chunk);
        }
        return chunk;
    }),
};
//# sourceMappingURL=index.js.map